import gap from 'MOBILE/Gap.js';

HSN.Gap = function (config) {
    const percentFire = 1.0;
    const randNum = Math.random() * 100;
    const message = '"HSN.Gap is deprecated.  Move to new Gap es2015 module.';

    if (randNum <= percentFire) {
        HSN.DataLayer.helpers.metricEvent(null, "JS:INFO", message, null, null, true);
    }

    console.warn(message);
    return gap;
}



// WEBPACK FOOTER //
// ./assets/js/mobile/OldGap.js